﻿import {JSX, lazy, ReactNode, Suspense, useEffect} from 'react';
import {GlobalContext} from "../contexts/GlobalContext";

interface InitializerProps {
	loading?: ReactNode;
	onInitialized?: () => void;
	children: ReactNode;
}

const AsyncInitializerInner = lazy(async () => {
	try {
		await GlobalContext.initialize();

		return {
			default: ({children, onInitialized}: { children: ReactNode; onInitialized?: () => void }) => {
				useEffect(() => {
					onInitialized?.()
				}, [onInitialized]);

				return GlobalContext.isReady() ? <>{children}</> : null;
			}
		};
	} catch (error) {
		// React Suspense doesn't automatically propagate async errors,
		// so we must rethrow inside a component that will be rendered.
		return {
			default: () => {
				throw error;
			}
		};
	}
});

export default function AsyncInitializer({children, loading, onInitialized}: InitializerProps): JSX.Element {
	return <Suspense fallback={loading}>
		<AsyncInitializerInner onInitialized={onInitialized}>{children}</AsyncInitializerInner>
	</Suspense>;
}
